import React, { useEffect, useState } from 'react';

import gallery01 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/01.jpg';
import gallery02 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/02.jpg';
import gallery03 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/03.jpg';
import gallery04 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/04.jpg';
import gallery05 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/05.jpg';
import gallery06 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/06.jpg';
import gallery07 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/07.jpg';
import gallery08 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/08.jpg';
import gallery09 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/09.jpg';
import gallery10 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/10.jpg';
import gallery11 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/11.jpg';
import gallery12 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/12.jpg';
import gallery13 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/13.jpg';
import gallery14 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/14.jpg';
import gallery15 from '../../../../Assets/Linkages/InternationalConferences/ICASTGallery/15.jpg';

const images = [
  gallery01, gallery02, gallery03, gallery04, gallery05,
  gallery06, gallery07, gallery08, gallery09, gallery10,
  gallery11, gallery12, gallery13, gallery14, gallery15,
];

const getVisibleCount = () => {
  if (window.innerWidth < 650) return 1;
  if (window.innerWidth < 1050) return 2;
  return 4;
};

const ICASTGallery = () => {
  const [start, setStart] = useState(0);
  const [visible, setVisible] = useState(getVisibleCount);

  useEffect(() => {
    const resize = () => {
      setVisible(getVisibleCount());
      setStart(0);
    };
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setStart((current) => (current + visible) % images.length);
    }, 3000);
    return () => window.clearInterval(timer);
  }, [visible]);

  const shown = Array.from({ length: visible }, (_, index) => images[(start + index) % images.length]);

  return (
    <section className="icast-gallery-section" aria-labelledby="icast-gallery-title">
      <div className="icast-gallery-inner">
        <p className="section-eyebrow">MOMENTS FROM ICAST</p>
        <h2 id="icast-gallery-title">Gallery</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <div className="icast-gallery-slider" aria-live="off">
          {shown.map((image, index) => (
            <figure className="icast-gallery-item" key={`${start}-${index}`}>
              <img src={image} alt={`ICAST conference moment ${((start + index) % images.length) + 1}`} loading="lazy" />
            </figure>
          ))}
        </div>
        <div className="icast-partners-controls">
          <button type="button" onClick={() => setStart((start - visible + images.length) % images.length)} aria-label="Previous gallery images">←</button>
          <span>{String(start + 1).padStart(2, '0')} / {images.length}</span>
          <button type="button" onClick={() => setStart((start + visible) % images.length)} aria-label="Next gallery images">→</button>
        </div>
      </div>
    </section>
  );
};

export default ICASTGallery;
